import { Injectable } from '@angular/core';
declare var webkitSpeechRecognition: any;

@Injectable({
  providedIn: 'root'
})
export class SpeechRecognitionService {

  recognition = new webkitSpeechRecognition();
  isStoppedSpeechRecog = false;
  text = '';
  tempWords: string = '';

  constructor() { }


  init() {

    this.recognition.interimResults = true;
    this.recognition.lang = 'pt-BR';
    this.recognition.addEventListener('result', (e: any) => {
      const transcript = Array.from(e.results).map((result: any) => result[0]).map((result) => result.transcript).join('');
      this.tempWords = transcript;
    });
  }

  start() {

    this.isStoppedSpeechRecog = false;
    this.text = '';
    this.recognition.start();

    this.recognition.addEventListener('end', (condition: any) => {

      if (this.isStoppedSpeechRecog) {

        this.recognition.stop();
      }
      else {
        this.wordConcat()
        this.recognition.start();
      }
    });
  }

  stop() {
    this.isStoppedSpeechRecog = true;
    this.wordConcat()
    this.recognition.stop();
  }

  wordConcat() {

    this.tempWords = this.tempWords.replaceAll("interrogação","?")
    this.tempWords = this.tempWords.replaceAll("exclamação","!")
    this.tempWords = this.tempWords.replaceAll("ponto e vírgula",";")
    this.tempWords = this.tempWords.replaceAll("dois pontos",":")
    this.tempWords = this.tempWords.replaceAll("2 pontos",":")
    this.tempWords = this.tempWords.replaceAll("ponto",".")
    this.tempWords = this.tempWords.replaceAll("parágrafo","   ")
    this.tempWords = this.tempWords.replaceAll("vírgula",",")
    this.tempWords = this.tempWords.replaceAll("abre parênteses","(")
    this.tempWords = this.tempWords.replaceAll("fecha parênteses",")")
    this.tempWords = this.tempWords.replaceAll("abre aspas",'"')
    this.tempWords = this.tempWords.replaceAll("fecha aspas",'"')
    this.tempWords = this.tempWords.replaceAll("fecha aspas",'"')
    this.tempWords = this.tempWords.replaceAll("nova linha",'\n')
    this.tempWords = this.tempWords.replaceAll("soma",'+')
    this.tempWords = this.tempWords.replaceAll("hífen",'-')
    this.text = this.text + ' ' + this.tempWords;
    this.tempWords = '';
  }

  getText() {
    return this.text;
  }
}